import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const inboundTaskCheckQtyRBAC = {
  pageID: 'fe6a09099c17367c0fad11b5e39263d7',
  elementID: {},
} as const

export const useRBACInboundTaskCheckQtyPage = createUseRBAC(inboundTaskCheckQtyRBAC.elementID)

export type UseRBACInboundTaskCheckQtyPageType = ReturnType<typeof useRBACInboundTaskCheckQtyPage>
